import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import white1 from "../../../assets/images/white1.jpg";
import white2 from "../../../assets/images/white2.jpg";
import white3 from "../../../assets/images/white3.jpg";
import white4 from "../../../assets/images/white4.jpeg";
import white5 from "../../../assets/images/white5.jpg";
import white6 from "../../../assets/images/white6.jpg";
import white7 from "../../../assets/images/white7.jpeg";
import table from "../../../assets/type-tables/הסוג מטרנית ומטריינית.xls";
import BackButton from "../../backButton";

const SandAndDesertMushrooms = () => {
  return (
    <div className="inner-section" id="sandAndDesertMushrooms">
      <Helmet>
        <title>פטרידע - פטריות החולות והמדבר</title>
        <meta
          name="description"
          content="פטריות החולות והמדבר: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="sandAndDesertMushrooms" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText1" />
          </p>
          <br />
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText2" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText3" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText4" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText5" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText6" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText7" />
          </p>
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText8" />
          </p>
          <br />
          <p>
            <MultiLingualContent contentID="sandAndDesertMushroomsText9" />
          </p>
        </div>
      </>
    </div>
  );
};

export default SandAndDesertMushrooms;
